module.exports = __webpack_public_path__ + "static/media/vlogo.15f8dfbf.svg";